module.exports = __webpack_public_path__ + "static/bf-exp-655fb431481acbe02243af9fdade5b0f.svg";